import { MKConstants, MKCustomError } from "../../constants";
import { MKError } from "../../interfaces";

/**
 * Azuki request error object.
 * @internal
 */
export class MKAdobeSessionConcurrencyError implements MKError {
    code: string;
    name: string;
    message: string;

    constructor(error: any) {
        this.name = "MKAdobeSessionConcurrencyError";
        const errorCodeTemplate = MKConstants.ErrorCodeTemplate.AdobePrimetimeSessionConcurrencyError;
        if (typeof error === "object" && error.code !== undefined && typeof error.code === "number") {
            this.code = this.code = errorCodeTemplate.replace("{code}", error.code.toString());
            switch(error.code) {
                case 400:
                    this.message = "Bad Request. Insufficient metadata.";
                    break;
                case 401:
                    this.message = "Unauthorized. Invalid or missing application ID.";
                    break;
                case 404:
                    this.message = "Not found. This session ID is not generated by the server.";
                    break;
                case 409:
                    this.message = "Conflict. Session terminated.";
                    break;
                case 410:
                    this.message = "Gone. Session no longer active.";
                    break;
                default:
                    // 5xx or other HTTP error
                    this.code = errorCodeTemplate.replace("{code}", MKCustomError.Http.code);
                    this.message = MKCustomError.Http.message;
                    break;
            }
        } else {
            // When error code and message could not be determined
            this.code = errorCodeTemplate.replace("{code}", MKCustomError.Http.code);
            this.message = MKCustomError.Http.message;
        }
    }
}